import swal from 'sweetalert2'

export default {
	changes() {
		return swal({
			title: 'You have unsaved changes.',
			text: 'Are you sure you want to perform this action?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			customClass: 'animated bounceIn',
			animation: false,
			confirmButtonText: 'Yes, continue!'
		});
	},

	success({ title = 'Success!', text = '', timer = 2500 }) {
		return swal({
			title,
			text,
			type: 'success',
			customClass: 'animated bounceIn',
			animation: false,
			showConfirmButton: false,
			timer
		});
	},

	confirm(options) {
		return swal($.extend({
			title: 'Are you sure?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			customClass: 'animated bounceIn',
			animation: false,
			confirmButtonText: 'Yes, I am sure.'
		}, options));
	},

	custom(options) {
		return swal($.extend({
			customClass: 'animated bounceIn',
			animation: false
		}, options));
	},

	delete(options = {}) {
		return swal($.extend({
			title: 'Warning!',
			text: 'Are you sure you want to perform this delete?',
			type: 'error',
			customClass: 'animated bounceIn',
			animation: false,
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			confirmButtonText: 'Yes, continue!'
		}, options));
	},

	error({ title = 'Uh oh!', text, options = {}}) {
		return swal($.extend({
			title,
			text,
			type: 'error',
			customClass: 'animated bounceIn',
			animation: false,
			confirmButtonColor: '#d33',
			confirmButtonText: 'Okay.'
		}, options));
	}
}



// WEBPACK FOOTER //
// ./src/utils/alert.js